export enum ModalResult{
    Cancel = 0, 
    Button1 = 1,
    Button2 = 2
}